

import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';
import AddingModel from '../common/adding-model';

import {connect} from 'react-redux'
import {GetUserToken, PostToBackend} from "../../api/services";
import eConfig from '../../config';



class SettingDealerComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            List: [],
            Current: null,
            modeList: true,
            modeUpdate:false,
            newEntry:{
                DealerRef :"",
                CommTotal :"",
                CommVendor :"",
                CommDealer :"",
                CommAgent :"",
            }
        }

    }

    async componentDidMount() {
        await this.isSupperUser()
        await this.fetchCommissionStructure();
        await this.fetchDealers();

    }
    isSupperUser=async ()=>{
        let user = GetUserToken();
        const role = user.Role;
        if(role!=="super"){
            alert("Sorry you can't perform this action,Your role is: "+role+"");
            window.location.href="#/home"
        }
    }
    fetchCommissionStructure = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("CommissionStructure", conds, (data) => {
            console.log("fetchCommissionStructure :> ", data);
            _this.setState({
                List: data,
            });
        });
    }
    fetchDealers = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("dealership", conds, (data) => {
            console.log("fetchCommissionStructure :> ", data);
            _this.setState({
                Dealers: data,
            });
        });
    }
    fetchingAll = async (table, conds, callback) => {

        const user = GetUserToken();
        console.log("User :> ", user);

        let hub = {
            Fields: [],
            DbName: "chela",
            TableName: table,
            Conditions: conds,
        }
        //  /backend-ecare/api/global-service
        let backend = eConfig.mainBackend;
        let endpoint = "/api/global-service/list";

        console.log("fetchingAll send > ", table, hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchingAll response > ", table, dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                callback(data);

            }
        });
    }

    viewListDetail = (row) => {
        console.log("View List detail Dealer ", row);
        let o = {
            Ref :row.ref,
            Email :row.email,
            Phone :row.phone,
            Name :row.name,
            ContactPerson :row.contactperson,
            ContactPhone :row.contactphone,
            ContactAddress :row.contactaddress,
        }

        let tmp = this.state;
        tmp.newEntry = o;
        tmp.modeList = false;
        tmp.modeUpdate = true;
        this.setState(tmp);

    }
    closeView=()=>{
        let tmp = this.state;
        tmp.newEntry={
            DealerRef :"",
            CommTotal :"",
            CommVendor :"",
            CommDealer :"",
            CommAgent :"",
        }

        tmp.modeList = true;
        tmp.modeUpdate = false;
        this.setState(tmp);
    }

    submitEntry=async ()=>{
        let _this = this;
        if(!window.confirm("Are you sure that you want to add this Dealer?")){
            return
        }
        //TODO validation here

        let hub={...this.state.newEntry};
        let o={
                DealerRef :hub.DealerRef,
                CommTotal :parseFloat(hub.CommTotal),
                CommVendor :parseFloat(hub.CommVendor),
                CommDealer :parseFloat(hub.CommDealer),
                CommAgent :parseFloat(hub.CommAgent),
        }
        hub = o;
        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-finance/manage/commission-structure/add";

        console.log("submitEntry send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("submitEntry response > ", dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                if(data !=="ADDED"){
                    alert(data)
                }else{
                    alert("Thank you commission structure  added!");
                    _this.closeView();
                    _this.fetchCommissionStructure();
                }
            }
        });

    }

    renderList = () => {

        if (!this.state.modeList) {
            return null
        }

        return this.state.List.map((row, index) => {
            return (<tr key={index}>
                <td>{row.dealerref}</td>
                <td>{row.commtotal}</td>
                <td>{row.commvendor}</td>
                <td>{row.commdealer}</td>
                <td>{row.commagent}</td>
                <td>
                    <a
                        onClick={() => {
                            this.viewListDetail(row)
                        }}
                        style={{cursor: "pointer"}}
                    >View Detail</a>
                    &nbsp;&nbsp;|&nbsp;&nbsp;

                </td>
            </tr>)
        })

    }

    getNewEntryValue=(key)=>{
        return this.state.newEntry[key];
    }
    setNewEntryValue=(e,key)=>{
        let tmp=this.state;
        tmp.newEntry[key] = e.target.value;
        this.setState(tmp);
    }
    newEntryForm=()=>{
        if(this.state.modeList){
            return null
        }

        /*
        DealerRef string
	CommTotal float64
	CommVendor float64
	CommDealer float64
	CommAgent float64
         */

        let forms=[
            {name:"CommTotal",desc:"Total Commission %",placeHolder:"e.g. 6%",type:"text",required:true},
            {name:"CommVendor",desc:"Vendor Commission %",placeHolder:"e.g. 1%",type:"text",required:true},
            {name:"CommDealer",desc:"Dealer Commission",placeHolder:"e.g. 2%",type:"text",required:true},
            {name:"CommAgent",desc:"Agent Commission",placeHolder:"e.g. 3%",type:"text",required:true},
        ];

        const innerRender=(inObject,index)=>{
            let myReadOnly = false;
            if(this.state.modeUpdate){
                myReadOnly=true
                /*if(inObject.name ==="Ref" || inObject.name==="Email"){
                    myReadOnly=true
                }*/
            }
            return(
                <div className="form-group" key={index}>
                    <label htmlFor="exampleInputEmail1">{inObject.desc}</label>
                    <input
                        type={inObject.type}
                        className="form-control"
                        id={inObject.name}
                        placeholder={inObject.placeHolder}
                        required={inObject.required}
                        value={this.getNewEntryValue(inObject.name)}
                        onChange={(e)=>this.setNewEntryValue(e,inObject.name)}
                        disabled={myReadOnly}
                    />
                </div>
            )
        }


        let myReadOnly = false;
        if (this.state.modeUpdate) {
            myReadOnly = true
        }


        const optionsDealer=()=>{
            let ls=[];
            const role = GetUserToken().Role;
            const email = GetUserToken().Username;

            for(let i in this.state.Dealers){
                const row = this.state.Dealers[i];
                if(role ==="super"){
                    ls.push({
                        name:row.ref,
                        desc:row.name,
                    })
                }
                if(role ==="dealer"){
                    if(email ===row.email){
                        ls.push({
                            name:row.ref,
                            desc:row.name,
                        })
                    }

                }
            }

            return ls.map((row,index)=>{
                return(
                    <option value={row.name}>{row.name +" "+row.desc}</option>
                )
            })
        }

        return(
            <div className="row">

                <div className="col-xs-12 col-lg-6">

                    {!this.state.modeUpdate?
                        <h3 className={"alert alert-info"}>New Dealer</h3>
                        :
                        <h3 className={"alert alert-danger"}>Update Dealer Info</h3>
                    }
                    <form onSubmit={this.submitEntry}>
                        {forms.map((row, index)=>{
                            return innerRender(row,index)
                        })}

                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Dealer</label>
                            <select
                                className="form-control"
                                required={true}
                                value={this.getNewEntryValue("DealerRef")}
                                onChange={(e) => this.setNewEntryValue(e, "DealerRef")}
                                disabled={myReadOnly}
                            >
                                <option value={""}>--Select your Dealer--</option>
                                {optionsDealer()}
                            </select>
                        </div>



                        {!this.state.modeUpdate ?
                            <button
                                className={"btn btn-primary pull-right"}
                                type={"submit"}
                            >Submit</button>
                            :
                            <button
                                className={"btn btn-danger pull-right"}
                                type={"button"}
                                onClick={()=>this.closeView()}
                            >Close</button>
                        }
                    </form>
                </div>
            </div>
        )
    }


    render() {

        return (


            <PageContentWallpaper {...this.props} >

                <div className="row">
                    <div className="col-xs-12">
                        <h2>Commission Structure Management
                            {!this.state.modeList?
                                <a className={"btn btn-danger pull-right"}
                                   onClick={() => this.setState({modeList:true,modeUpdate:false})}>Cancel</a>
                                :
                                <a className={"btn btn-primary pull-right"}
                                   onClick={() => this.setState({modeList:false})}>New Commission</a>
                            }
                        </h2>
                    </div>

                </div>

                {this.state.modeList?
                    <div className="row">
                        <div className="col-xs-12">

                            <table className="table">
                                <thead>
                                <tr>
                                    <th>Dealer Ref</th>
                                    <th>Total %</th>
                                    <th>Vendor %</th>
                                    <th>Dealer %</th>
                                    <th>Agent %</th>
                                    <th>#</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.renderList()}
                                </tbody>
                            </table>

                        </div>
                    </div>:null}


                {this.newEntryForm()}

            </PageContentWallpaper>
        )


    }

}

const mapDispatchToProps = dispatch => ({
    dispatch: dispatch
})

const mapStateToProps = state => ({
    addingModel: state.addingModel,
    login: state.login
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingDealerComponent)